import PendingModal from './PendingModal';

const Review = {
  PendingModal,
};

export default Review;
